export const ADMIN_ROLES = {
  ADMIN: 1,
  MANAGER: 2,
  WAREHOUSE: 3,
};
